<template>
    <div class="tarja-top">
        {{ localData }}
    </div>
</template>

<script>
/*
 * Tarja superior: município e data.
 *
 * O componente tinha APENAS `<template>` e referenciava `identidade` — que nunca existiu
 * na instância. O Vue avisava "Property or method 'identidade' is not defined" e a leitura
 * de `identidade.municipio_uf` estourava TypeError a cada render, em toda tela do portal.
 *
 * A identidade vem do backend pelo mixin, que já entrega um padrão antes da resposta
 * chegar — a tarja nunca fica em branco nem quebra sem rede.
 */
import { identidadeMixin } from '@/shared/identidade'

export default {
    mixins: [identidadeMixin],

    computed: {
        localData () {
            const lugar = this.identidade.municipio_uf || this.identidade.municipio || ''
            const data = new Date().toLocaleDateString('pt-BR')

            return lugar ? `${lugar}, ${data}` : data
        }
    }
}
</script>

<style scoped>
.tarja-top {
    text-align: right;
    padding-right: 80px;
}
</style>
